/*
forgot-password-popup.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('login/modules/forgot-password-popup/forgot-password-popup',['angular', 'ui-router', './controllers/forgot-password-popup-ctrl'], function () {

    // Module Dependencies
    var dependencies = [
        //vendor
        'ui.router',
        'ForgotPasswordPopUp.Controllers.ForgotPasswordPopUpCtrl'
    ];

// Module Creation
    var mod = angular.module('Login.Modules.ForgotPasswordPopUp', dependencies);

//Routing Config
    mod.config(['$stateProvider', function ($stateProvider) {

// Define the login app's states
        $stateProvider
            .state('app.login.forgotPassword', {
                views: {
                    'forgot-password-form': {
                        templateUrl: 'javascripts/login/modules/forgot-password-popup/templates/forgot-password-form.html',
                        controller: 'ForgotPasswordPopUpCtrl'
                    }
                }
            });
    }]);

});

